import { CompanyDetailSelectModel } from 'hq/services/mappers/mappers';
import { Grid, Typography } from '@mui/material';
import { useMemo } from 'react';

export const CompanyInfo = ({ data }: { data: CompanyDetailSelectModel }) => {
  const acceptedReceiptsString = useMemo(() => {
    if (data.receiptCertificates?.length) {
      return data.receiptCertificates.map((certificate) => certificate.name).join(', ');
    }
    return '-';
  }, [data.receiptCertificates]);

  return (
    <Grid item container spacing={3} xs={8}>
      <Grid item xs={6}>
        <Typography variant="subtitle1">Bedrijfsnaam</Typography>
        <Typography variant="body2">{data.name}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="subtitle1">Biedt uitzendwerk aan</Typography>
        <Typography variant="body2">{data.offersTempWork === true ? 'Ja' : 'Nee'}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="subtitle1">Minimum leeftijd uitzendkracht</Typography>
        <Typography variant="body2">{data.minimumTempWorkerAge ?? '-'}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="subtitle1">Biedt freelance werk aan</Typography>
        <Typography variant="body2">{data.offersFreelanceWork === true ? 'Ja' : 'Nee'}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="subtitle1">Biedt werk in loondienst aan</Typography>
        <Typography variant="body2">{data.offersEmployeeWork === true ? 'Ja' : 'Nee'}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="subtitle1">Minimale tijd tussen shifts (in uren)</Typography>
        <Typography variant="body2">{data.workCooldownMinutes / 60}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="subtitle1">
          Certificaten die worden geaccepteerd als ontvangstbewijzen
        </Typography>
        <Typography variant="body2">{acceptedReceiptsString}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="subtitle1">Laat gebruikers het bedrijfsthema aanpassen</Typography>
        <Typography variant="body2">
          {data.themeCustomizationEnabled === true ? 'Ja' : 'Nee'}
        </Typography>
      </Grid>
    </Grid>
  );
};
